import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import MultiSelect from "multiselect-react-dropdown";
import { get } from "lodash";
import imagelogo from "../../../images/medvrLogoBlk.jpg";
import { Select } from "antd";

function AddPortal(props) {
  const [IntentList, setIntentList] = useState([]);
  const [modal, setModal] = useState(false);
  const [formData, setName] = useState({
    portalName: "",
    ukey: "",
    gptkey: "",
    conapi: "",
    secapi: "",
    baseUrl: "",
    scenarioBaseUrl: "",
    custBgLimit: 0,
    casesLimitPerInterval: 0,
    casesLimitInterval: 0,
    casesLimitStartDate: getTodayDate(),
    survey_text: "",
    system_promt: "",
    cases_promt: "",
    blacklisted_keywords: [],
  });
  const [ShowLegacyCases, setShowLegacyCases] = useState(false);
  const [formData2, setName2] = useState({ intents: "", Ans1: "", Ans2: "" });
  const [Emotion, setEmotion] = React.useState("");
  const [EType, setType] = React.useState("");
  const [value, setValue] = useState();
  const navigate = useHistory();
  const [UserList, setUserList] = useState([]);
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [ScenarioEnvList, setScenarioEnvList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [SelectedList, setSelectedList] = useState([]);
  const [EnvSelectedList, setEnvSelectedList] = useState([]);
  const [ScenarioEnvSelectedList, setScenarioEnvSelectedList] = useState([]);
  const [CharacterSelectedList, setCharacterSelectedList] = useState([]);
  const [file, setFile] = useState();
  const [Colr1, setColr1] = useState("");
  const [Colr2, setColr2] = useState("");
  const [Colr3, setColr3] = useState("");
  const [environmentImg, setEnvironmentImg] = useState("");
  const [scenarioEnvImg, setScenarioEnvImg] = useState("");
  const [characterImg, setCharacterImg] = useState("");

  const colorPickerRef1 = useRef();
  const colorPickerRef2 = useRef();
  const colorPickerRef3 = useRef();

  // Code for Filtered Keywords
  const [inputFields, setInputFields] = useState([{ key: '', value: '' }]); // Initial state with one key-value pair

  const handleInputChange = (index, event, keyOrValue) => {
    const values = [...inputFields];
    values[index][keyOrValue] = event.target.value;
    setInputFields(values);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { key: '', value: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  // End of Code for Filtered Keywords

  // Function to get today's date in the format "YYYY-MM-DD"
  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    // Ensure month and day are always two digits
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }

    return `${year}-${month}-${day}`;
  }

  // Event handler to update selectedDate
  // const handleDateChange = (event) => {
  //   setSelectedDate(event.target.value);
  // };


  const onSelect = (selectedList, selectedItem) => {
    // console.log(selectedItem);
    setSelectedList(selectedList);
    //console.log('The selected data', selectedList);
  };

  const onEnvSelect = (envSelectedList, envSelectedItem) => {
    setEnvSelectedList(envSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetEnvironmentImageById?EnvironmentId=` + envSelectedItem.id;
    setEnvironmentImg(imagepath);
  };

  const onScenarioEnvSelect = (scenarioEnvSelectedList, scenarioEnvSelectedItem) => {
    setScenarioEnvSelectedList(scenarioEnvSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetScenarioEnvImageById?EnvironmentId=` + scenarioEnvSelectedItem.id;
    setScenarioEnvImg(imagepath);
  };

  const onCharacterSelect = (characterSelectedList, characterSelectedItem) => {
    setCharacterSelectedList(characterSelectedList);
    var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + characterSelectedItem.id;
    setCharacterImg(imagepath);
  };

  const onRemove = (selectedList, removedItem) => {
    //console.log('The selected data', selectedList);
  };

  const onEnvRemove = (selectedList, removedItem) => {
    //console.log('The selected data', selectedList);
    setEnvironmentImg("");
  };

  const onScenarioEnvRemove = (selectedList, removedItem) => {
    //console.log('The selected data', selectedList);
    setScenarioEnvImg("");
  };

  const onCharacterRemove = (selectedList, removedItem) => {
    setCharacterImg("");
  };

  useEffect(() => {
    LoadUsers();
    LoadEnvironments();
    LoadScenarioEnvironments();
    LoadCharacters();
  }, []);

  const LoadUsers = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GetFilerUserByUserPortal`)
      .then((res) => {
        //console.log("list", res.data)
        setUserList(res.data);
      });
  };

  const LoadEnvironments = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GeFiltertEnvironmentByUserPortal`)
      .then((res) => {
        //console.log("list", res.data)
        setEnvironmentList(res.data);
      });
  };

  const LoadScenarioEnvironments = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GetFiltertScenarioEnvByUserPortal`)
      .then((res) => {
        setScenarioEnvList(res.data);
      });
  };

  const LoadCharacters = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/GeFiltertCharacterByUserPortal`)
      .then((res) => {
        setCharacterList(res.data);
      });
  };

  const Loginsubmit = async (e) => {
    e.preventDefault();

    if (inputFields.some(field => field.key === '')) {
      Swal.fire({
        title: "Error",
        text: "Key can not be empty",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    const filterable_texts = inputFields.map(({ key, value }) => `${key}:${value}`).join(', ');

    let formDataSet = new FormData(); //formdata object

    if (
      formData.portalName === "" ||
      formData.system_promt === "" ||
      formData.cases_promt === "" ||
      formData.secapi === "" ||
      formData.baseUrl === "" ||
      formData.scenarioBaseUrl === "" ||
      EnvSelectedList.length === 0 ||
      CharacterSelectedList.length === 0
    ) {
      if (formData.portalName === "") {
        Swal.fire({
          title: "Error",
          text: "Portal Name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.system_promt === "") {
        Swal.fire({
          title: "Error",
          text: "System Prompt Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.cases_promt === "") {
        Swal.fire({
          title: "Error",
          text: "Cases Prompt Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.secapi === "") {
        Swal.fire({
          title: "Error",
          text: "Security Key Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.baseUrl === "") {
        Swal.fire({
          title: "Error",
          text: "Base URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.scenarioBaseUrl === "") {
        Swal.fire({
          title: "Error",
          text: "Scenario Base URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (EnvSelectedList.length === 0) {
        Swal.fire({
          title: "Error",
          text: "Please select at least one Environment",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (CharacterSelectedList.length === 0) {
        Swal.fire({
          title: "Error",
          text: "Please select at least one Character",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      const datavalue = {
        Portal_Name: formData.portalName,
        Unique_KEY: formData.ukey,
        Chat_gpt_KEY: formData.gptkey,
        Congnitive_API: formData.conapi,
        Security_API: formData.secapi,
        Base_Url: formData.baseUrl,
        Scenario_Base_Url: formData.scenarioBaseUrl,
        Custom_Bg_Limit: formData.custBgLimit,
        Cases_Limit_Per_Interval: formData.casesLimitPerInterval,
        Cases_Limit_Interval: formData.casesLimitInterval,
        Cases_Limit_Start_Date: formData.casesLimitStartDate,
        survey_text: formData.survey_text,
        sidebar_Color: Colr1,
        brand_Color: Colr2,
        header_Color: Colr3,
        UserProfiles: SelectedList,
        Environments: EnvSelectedList,
        Scenario_Environments: ScenarioEnvSelectedList,
        Characters: CharacterSelectedList,
        system_promt: formData.system_promt,
        Cases_Promt: formData.cases_promt,
        blacklisted_keywords: formData.blacklisted_keywords.join(","),
        Show_Legacy_Cases: ShowLegacyCases,
        filtered_keywords: filterable_texts,
      };

      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/AddPortal`,
        data: datavalue,
        headers: { "Content-Type": "application/json", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          //console.log("get value", res);

          //console.log("success", res.data.SuccessResult)
          if (res.data.SuccessResult === "alredy") {
            Swal.fire({
              title: "Error",
              text: "Question Already inserted",
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else {
            // setName({ intents: "", Ans1: "", Ans2: "" });
            const imagevalue = {
              formFile: file,
            };

            var authOptions = {
              method: "post",
              url: `${process.env.REACT_APP_API_URL}/UploadPortalImage`,
              data: imagevalue,
              headers: { "Content-Type": "multipart/form-data" },
            };
            axios(authOptions).then((response) => {
              if (res.data.ExpResult) {
                Swal.fire({
                  title: "Failed",
                  text: res.data.ExpResult,
                  icon: "error",
                  confirmButtonText: "Ok",
                });
              } else if (res.data.SuccessResult) {
                Swal.fire({
                  title: "Success",
                  text: res.data.SuccessResult,
                  icon: "success",
                  confirmButtonText: "Ok",
                }).then(function () {
                  window.location.reload(true);
                });
              } else {
                Swal.fire({
                  title: "Error",
                  text: "An error occured!",
                  icon: "error",
                  confirmButtonText: "Ok",
                });
              }
              // Swal.fire({
              //   title: "Success",
              //   text: "Portal Added",
              //   icon: "success",
              //   confirmButtonText: "Ok",
              // }).then(function () {
              //   // window.location.pathname = "/IntentAns";
              // });
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const updateBlacklistText = (e) => {
    setName({ ...formData, blacklisted_keywords: e });
  };
  const onUpload = (event) => {
    const imagevalue = {
      formFile: get(event, "target.files[0]"),
    };
    setFile(get(event, "target.files[0]"));
  };
  const onSelectColor1 = () => {
    const color = colorPickerRef1.current.value;
    setColr1(color);
    // console.log('selected color1', color);
  };
  const onSelectColor2 = () => {
    const color = colorPickerRef2.current.value;
    setColr2(color);
    // console.log('selected color22', color);
  };
  const onSelectColor3 = () => {
    const color = colorPickerRef3.current.value;
    setColr3(color);
    // console.log('selected color33', color);
  };

  const toggle2 = () => setModal(!modal);

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };
  const handleChangeDrp = (event) => {
    setEmotion(event.target.value);
    //console.log("selected emo", event.target.value)
  };

  function handleChangeShowLegacyCases(e) {
    setShowLegacyCases(e.target.checked);
  }

  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Add Portal</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="card card-box">
                <div className="card-head">
                  <header>Portal</header>
                </div>
                <div className="card-body " id="bar-parent">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={Loginsubmit}
                  >
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Potal Name
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.portalName}
                            onChange={handleChange}
                            name="portalName"
                            className="form-control"
                            id="ans1"
                            placeholder="Portal Name"
                          />
                        </div>
                        {/* <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Unique Key
                          </label>
                          <input
                            type="text"
                            value={formData.ukey}
                            onChange={handleChange}
                            name="ukey"
                            className="form-control"
                            id="ans1"
                            placeholder="Unique Key"
                          />
                        </div> */}
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            ChatGPT
                          </label>
                          <input
                            type="text"
                            value={formData.gptkey}
                            onChange={handleChange}
                            name="gptkey"
                            className="form-control"
                            id="ans2"
                            placeholder="ChatGPT"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="baseUrl"
                            className="control-label"
                          >
                            Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.baseUrl}
                            onChange={handleChange}
                            name="baseUrl"
                            className="form-control"
                            id="baseUrl"
                            placeholder="Base URL"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="scenarioBaseUrl"
                            className="control-label"
                          >
                            Scenario Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.scenarioBaseUrl}
                            onChange={handleChange}
                            name="scenarioBaseUrl"
                            className="form-control"
                            id="scenarioBaseUrl"
                            placeholder="Scenario Base URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="custBgLimit"
                            className="control-label"
                          >
                            Image Generation Limit
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            min={0}
                            value={formData.custBgLimit}
                            onChange={handleChange}
                            name="custBgLimit"
                            className="form-control"
                            id="custBgLimit"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="custBgRemaining"
                            className="control-label"
                          >
                            Image Generation Remaining
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            value={formData.custBgLimit}
                            //onChange={handleChange}
                            name="custBgRemaining"
                            className="form-control"
                            id="custBgRemaining"
                            disabled={true}
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>




                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitPerInterval"
                            className="control-label"
                          >
                            Cases Limit (per interval)
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            min={0}
                            value={formData.casesLimitPerInterval}
                            onChange={handleChange}
                            name="casesLimitPerInterval"
                            className="form-control"
                            id="casesLimitPerInterval"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="casesRemaining"
                            className="control-label"
                          >
                            Cases Remaining
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            value={formData.casesLimitPerInterval}
                            name="casesLimitPerInterval"
                            className="form-control"
                            id="casesRemaining"
                            disabled={true}
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitInterval"
                            className="control-label"
                          >
                            Cases Limit Interval (in days)
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="number"
                            min={0}
                            value={formData.casesLimitInterval}
                            onChange={handleChange}
                            name="casesLimitInterval"
                            className="form-control"
                            id="casesLimitInterval"
                            placeholder="0"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            for="casesLimitStartDate"
                            className="control-label"
                          >
                            Cases Limit Start Date
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="date"
                            value={formData.casesLimitStartDate}
                            onChange={handleChange}
                            name="casesLimitStartDate"
                            className="form-control"
                            id="casesLimitStartDate"
                          />
                        </div>
                      </div>
                    </div>



                    <div className="form-group">
                      <div className="row">
                        {/* 
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Conginitive API
                          </label>
                          <input
                            type="text"
                            value={formData.conapi}
                            onChange={handleChange}
                            name="conapi"
                            className="form-control"
                            id="ans2"
                            placeholder="Conginitive API"
                          />
                        </div>*/}
                        <div className="col-12 col-md-6">
                          <label
                            for="simpleFormPassword"
                            className="control-label"
                          >
                            Security API
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.secapi}
                            onChange={handleChange}
                            name="secapi"
                            className="form-control"
                            id="ans2"
                            placeholder="Security API"
                          />
                        </div>

                        {/* <div className="col-12 col-md-6">
                          <label
                            for="baseUrl"
                            className="control-label"
                          >
                            Base URL
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <input
                            type="text"
                            value={formData.baseUrl}
                            onChange={handleChange}
                            name="baseUrl"
                            className="form-control"
                            id="baseUrl"
                            placeholder="Base URL"
                          />
                        </div> */}
                      </div>
                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="col-lg-3 col-md-4 control-label">
                            Manager List
                          </label>
                          <MultiSelect
                            options={UserList}
                            onSelect={onSelect}
                            onRemove={onRemove}
                            displayValue="first_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <div className="col-2">
                            <img
                              src={imagelogo}
                              style={{
                                width: "200px",
                                maxHeight: "50px",
                                objectFit: "contain",
                              }}
                              alt="new"
                            />
                          </div>
                          <div className="col-10">
                            <div
                              className="photoEdit mt-3"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="file"
                                onChange={onUpload}
                                id="myFile"
                                name="formFile"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">Sidebar Color</label>
                          <div class="input-group col-md-8">
                            <input
                              //   id="cp1"
                              type="color"
                              className="form-control"
                              name="colo1"
                              defaultValue="#FFFFFF"
                              ref={colorPickerRef1}
                              onChange={onSelectColor1}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">
                            Header Brand color
                          </label>
                          <div class="input-group col-md-8">
                            <input
                              type="color"
                              className="form-control"
                              name="colo2"
                              defaultValue="#FFFFFF"
                              ref={colorPickerRef2}
                              onChange={onSelectColor2}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <label class="control-label">Header color</label>
                          <div class="input-group col-md-8">
                            <input
                              type="color"
                              className="form-control"
                              name="colo3"
                              defaultValue="#FFFFFF"
                              ref={colorPickerRef3}
                              onChange={onSelectColor3}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <label class="control-label">System Prompt</label>
                          <textarea
                            className="form-control"
                            name="system_promt"
                            style={{ width: "100%", height: "100px" }}
                            value={formData.system_promt}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <label class="control-label">Cases Prompt</label>
                          <textarea
                            className="form-control"
                            name="cases_promt"
                            style={{ width: "100%", height: "100px" }}
                            value={formData.cases_promt}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="col-lg-6 col-md-6 control-label">
                            Blacklisted Keywords
                          </label>
                          {/* <MultiSelect
                            options={UserList}
                            onSelect={onSelect}
                            onRemove={onRemove}
                            selectedValues={[]}
                            displayValue="first_Name"
                          /> */}

                          <Select
                            mode="tags"
                            style={{ width: "100%" }}
                            placeholder="Tags Mode"
                            name="blacklisted_keywords"
                            onChange={(e) => updateBlacklistText(e)}
                            options={[]}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label class="control-label">Filter Keywords</label>
                      {inputFields.map((field, index) => (
                        <div key={index}>

                          <div class="form-group row">
                            <div className="col-md-6 col-sm-6">
                              <div className="form-group row">
                                <div className="col-md-5 col-sm-5">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Key"
                                    value={field.key}
                                    onChange={(event) => handleInputChange(index, event, 'key')}
                                  />
                                </div>
                                <div className="col-md-5 col-sm-5">
                                  <input
                                    type="text"
                                    placeholder="Value"
                                    className="form-control"
                                    value={field.value}
                                    onChange={(event) => handleInputChange(index, event, 'value')}
                                  />
                                </div>
                                <div className="col-md-2 col-sm-2">
                                  <button type="button" className="btn btn-danger" onClick={() => handleRemoveFields(index)}>
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="form-group row">
                        <div className="col-md-5 col-sm-5 d-flex justify-content-center">
                          <button type="button" className="btn btn-success" onClick={handleAddFields}>
                            Add
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Environment List
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <MultiSelect
                            options={EnvironmentList}
                            onSelect={onEnvSelect}
                            onRemove={onEnvRemove}
                            displayValue="environment_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={environmentImg} target="_blank" rel="noopener">
                            <img
                              src={environmentImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Scenario Environment List
                          </label>
                          {/* <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          /> */}
                          <MultiSelect
                            options={ScenarioEnvList}
                            onSelect={onScenarioEnvSelect}
                            onRemove={onScenarioEnvRemove}
                            displayValue="environment_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={scenarioEnvImg} target="_blank" rel="noopener">
                            <img
                              src={scenarioEnvImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      {/* <div className="card-body " id="bar-parent10"> */}
                      <div className="form-group row">
                        <div className="col-md-6 col-sm-6">
                          <label className="control-label">
                            Character List
                          </label>
                          <i
                            className="fa fa-asterisk"
                            style={{
                              fontSize: "10px",
                              color: "red",
                              padding: "4px",
                            }}
                          />
                          <MultiSelect
                            options={CharacterList}
                            onSelect={onCharacterSelect}
                            onRemove={onCharacterRemove}
                            displayValue="character_Name"
                          />
                        </div>
                        <div className="col-md-6 col-sm-6 d-flex justify-content-center align-items-center">
                          <a href={characterImg} target="_blank" rel="noopener">
                            <img
                              src={characterImg}
                              style={{
                                width: "150px",
                                maxHeight: "150px",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div class="form-group row">
                        <div className="col-md-12 col-sm-12">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={handleChangeShowLegacyCases} checked={ShowLegacyCases} />
                            <label class="form-check-label" for="flexCheckDefault">
                              Show Legacy cases
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPortal;
